import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";

import Header from "./components/header/Header";

import KycComplete from "./pages/kyc-completed/KycComplete";

import DashboardTraveler from "./pages/dashboard-traveler/DashboardTraveler";
import TripsProgressTraveler from "./pages/dashboard-traveler/TripsProgressTraveler";
import TripsConcludedTraveler from "./pages/dashboard-traveler/TripsConcludedTraveler";
import PaymentInsurance from "./pages/dashboard-traveler/PaymentInsurance";

import DashboardClient from "./pages/dashboard-client/DashboardClient";
import TripsProgressClient from "./pages/dashboard-client/TripsProgressClient";
import TripsConcludedClient from "./pages/dashboard-client/TripsConcludedClient";
import PaymentService from "./pages/dashboard-client/PaymentService";
import TripTrackingClient from "./pages/dashboard-client/TripTracking";

import DashboardReceiver from "./pages/dashboard-receiver/DashboardReceiver";
import TripsProgressReceiver from "./pages/dashboard-receiver/TripsProgressReceiver";
import TripsConcludedReceiver from "./pages/dashboard-receiver/TripsConcludedReceiver";
import TripTrackingReceiver from "./pages/dashboard-receiver/TripTracking";

import Viagem from "./pages/Viagem/Viagem";
import MyProfile from "./pages/my-profile/MyProfile";
import Home from "./pages/home/Home";
import ComoFunciona from "./pages/como-funciona/ComoFunciona";
import PerguntasFrequentes from "./pages/perguntas-frequentes/PerguntasFrequentes";
import QualMeioTransporteCadastramento from "./pages/qual-meio-transporte-cadastramento/QualMeioTransporteCadastramento";
import OpcaoAviao from "./pages/cadastro-viagem/OpcaoAviao";
import OpcaoTrem from "./pages/cadastro-viagem/OpcaoTrem";
import OpcaoOnibus from "./pages/cadastro-viagem/OpcaoOnibus";
import OpcaoCarro from "./pages/cadastro-viagem/OpcaoCarro";
import OpcaoMoto from "./pages/cadastro-viagem/OpcaoMoto";
import Trajeto from "./pages/cadastro-viagem/Trajeto";
import CidadesTrajeto from "./pages/cadastro-viagem/CidadesTrajeto";
import DataHora from "./pages/cadastro-viagem/DataHora";
import EspacoDisponivel from "./pages/cadastro-viagem/EspacoDisponivel";
import OferecerEspacoNaVolta from "./pages/cadastro-viagem/OferecerEspacoNaVolta";
import Busca from "./pages/busca/Busca";
import Cadastro from "./pages/cadastro/Cadastro";
import ConfirmacaoEmail from "./pages/confirmacao-email/ConfirmacaoEmail";
import ConfirmacaoTelefone from "./pages/confirmacao-telefone/ConfirmacaoTelefone";
import EsqueciSenha from "./pages/esqueci-senha/EsqueciSenha";
import RedefinirSenha from "./pages/redefinir-senha/RedefinirSenha";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Routes>
        <Route
          path="/kyc/complete"
          element={
            <PrivateRoute>
              <KycComplete menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard-traveler"
          element={
            <PrivateRoute>
              <DashboardTraveler
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-progress-traveler"
          element={
            <PrivateRoute>
              <TripsProgressTraveler
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-concluded-traveler"
          element={
            <PrivateRoute>
              <TripsConcludedTraveler
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/payment-traveler"
          element={
            <PrivateRoute>
              <PaymentInsurance menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard-client"
          element={
            <PrivateRoute>
              <DashboardClient menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-progress-client"
          element={
            <PrivateRoute>
              <TripsProgressClient
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-concluded-client"
          element={
            <PrivateRoute>
              <TripsConcludedClient
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/payment-client"
          element={
            <PrivateRoute>
              <PaymentService menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </PrivateRoute>
          }
        />

        <Route
          path="/trip-tracking-client"
          element={
            <PrivateRoute>
              <TripTrackingClient
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard-receiver"
          element={
            <PrivateRoute>
              <DashboardReceiver
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-progress-receiver"
          element={
            <PrivateRoute>
              <TripsProgressReceiver
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trips-concluded-receiver"
          element={
            <PrivateRoute>
              <TripsConcludedReceiver
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/trip-tracking-receiver"
          element={
            <PrivateRoute>
              <TripTrackingReceiver
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/my-profile"
          element={
            <PrivateRoute>
              <MyProfile menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<Home />} />
        <Route
          path="/como-funciona"
          element={
            <ComoFunciona menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/perguntas-frequentes"
          element={
            <PerguntasFrequentes
              menuOpen={menuOpen}
              setMenuOpen={setMenuOpen}
            />
          }
        />

        <Route
          path="/qual-meio-transporte"
          element={
            <PrivateRoute>
              <QualMeioTransporteCadastramento
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
              />
            </PrivateRoute>
          }
        />

        <Route
          path="/aviao"
          element={<OpcaoAviao menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/trem"
          element={<OpcaoTrem menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/onibus"
          element={
            <OpcaoOnibus menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/carro"
          element={<OpcaoCarro menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/moto"
          element={<OpcaoMoto menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/trajeto"
          element={<Trajeto menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/cidades-trajeto"
          element={
            <CidadesTrajeto menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/data"
          element={<DataHora menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/espaco-disponivel"
          element={
            <EspacoDisponivel menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/oferecer-espaco-na-volta"
          element={
            <OferecerEspacoNaVolta
              menuOpen={menuOpen}
              setMenuOpen={setMenuOpen}
            />
          }
        />
        <Route
          path="/busca"
          element={<Busca menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/cadastro"
          element={<Cadastro menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
        />
        <Route
          path="/confirmacao-email"
          element={
            <ConfirmacaoEmail menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/confirmacao-telefone"
          element={
            <ConfirmacaoTelefone
              menuOpen={menuOpen}
              setMenuOpen={setMenuOpen}
            />
          }
        />
        <Route
          path="/esqueci-senha"
          element={
            <EsqueciSenha menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route
          path="/redefinir-senha"
          element={
            <RedefinirSenha menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          }
        />
        <Route path="/viagem" element={<Viagem />} />
      </Routes>
    </Router>
  );
}

export default App;
